import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BeforeAndAfterQuestionItemState {
  // sampleId -> currently selected optionId
  selections: Record<string, number>;
  // sampleId -> list of optionIds that have been submitted
  submittedSelections: Record<string, number[]>;
  isSubmitted: boolean;
}

export type BeforeAndAfterQuestionSliceState = Record<
  string,
  BeforeAndAfterQuestionItemState
>;

const getDefaultState = (): BeforeAndAfterQuestionItemState => ({
  selections: {},
  submittedSelections: {},
  isSubmitted: false,
});

const beforeAndAfterQuestionSlice = createSlice({
  name: "beforeAndAfter",
  initialState: {} as BeforeAndAfterQuestionSliceState,
  reducers: {
    selectOption: (
      state,
      action: PayloadAction<{
        componentID: string;
        sampleId: string;
        optionId: number;
      }>
    ) => {
      const { componentID, sampleId, optionId } = action.payload;
      if (!state[componentID]) {
        state[componentID] = getDefaultState();
      }
      state[componentID].selections[sampleId] = optionId;
    },
    submit: (state, action: PayloadAction<string>) => {
      const componentID = action.payload;
      if (!state[componentID]) {
        state[componentID] = getDefaultState();
      }
      const item = state[componentID];
      Object.entries(item.selections).forEach(([sampleId, optionId]) => {
        if (!item.submittedSelections[sampleId]) {
          item.submittedSelections[sampleId] = [];
        }
        if (!item.submittedSelections[sampleId].includes(optionId)) {
          item.submittedSelections[sampleId].push(optionId);
        }
      });
      item.isSubmitted = true;
    },
    reset: (state, action: PayloadAction<string>) => {
      state[action.payload] = getDefaultState();
    },
  },
});

export const beforeAndAfterQuestionActions =
  beforeAndAfterQuestionSlice.actions;
export const beforeAndAfterQuestionReducer =
  beforeAndAfterQuestionSlice.reducer;

export const selectBeforeAndAfterQuestionState = (
  state: { beforeAndAfter: BeforeAndAfterQuestionSliceState },
  componentId: string
) => state.beforeAndAfter?.[componentId] || getDefaultState();
